import {Auth0Error} from 'auth0-js';
import {Observable, Subscriber} from 'rxjs';

// @dynamic
export class Auth0Rx {
	constructor(protected instance:any) {}

	static exec(instance:any, method:string, ...args:any[]):Observable<any> {
		return Observable.create((subscriber:Subscriber<any>) => {
			instance[method](...args, (err:Auth0Error, result) => {
				if(err) subscriber.error(err);
				else {
					subscriber.next(result);
					subscriber.complete();
				}
			});
		});
	}

	call(method:string, ...args:any[]):Observable<any> {
		return Auth0Rx.exec(this.instance, method, ...args);
	}
}